import React from "react";
import { D, JAKARTA } from "../ui";

// Gaya bersama Studio AI Mall (selaras dengan Studio Aset: krem #f8f6ee, pil, label kapital kecil)
export const lbl = { display: "block", fontSize: 10.5, fontWeight: 800, color: D.sub, letterSpacing: 1.2, textTransform: "uppercase", margin: "0 0 5px 2px" };
export const inp = { width: "100%", padding: "10px 14px", background: "#fff", border: "1.5px solid #ece9dc", borderRadius: 14, fontSize: 13, color: "#141414", outline: "none", fontFamily: JAKARTA, boxSizing: "border-box" };

export function Pil({ tid, onClick, children, primary, danger, disabled, small, type = "button" }) {
  return (
    <button data-testid={tid} onClick={onClick} disabled={disabled} type={type}
      style={{ display: "inline-flex", alignItems: "center", gap: 6, padding: small ? "7px 12px" : "10px 18px", borderRadius: 99, fontSize: small ? 11.5 : 12.5, fontWeight: 700, fontFamily: JAKARTA, cursor: disabled ? "default" : "pointer",
        background: primary ? D.blue : danger ? "#fee2e2" : "#fff", color: primary ? "#fff" : danger ? "#b91c1c" : D.ink, border: primary || danger ? 0 : "1.5px solid #ece9dc", opacity: disabled ? 0.5 : 1, transition: "opacity .15s", whiteSpace: "nowrap" }}
      onMouseEnter={e => { if (!disabled) e.currentTarget.style.opacity = "0.85"; }} onMouseLeave={e => { if (!disabled) e.currentTarget.style.opacity = "1"; }}>
      {children}
    </button>
  );
}

export const statusBarang = it => (it.status === "terbit" ? ["Terbit di Mall", "#189a5b", "#d6f2e2"] : it.draft ? ["Draf Baru", D.blue, D.blueSoft] : it.paintCode ? ["Siap terbit", D.chipInk, D.chip] : ["Perlu AI", "#b45309", "#fde8d8"]);

export function ChipStatus({ it, tid }) {
  const [label, ink, bg] = statusBarang(it);
  return <span data-testid={tid} style={{ padding: "3px 10px", borderRadius: 99, fontSize: 10.5, fontWeight: 800, background: bg, color: ink, whiteSpace: "nowrap" }}>{label}</span>;
}

export function Modal({ children, onClose, testid, width = 880 }) {
  return (
    <div data-testid={testid} onClick={onClose} style={{ position: "fixed", inset: 0, zIndex: 100, background: "rgba(20,20,20,0.35)", backdropFilter: "blur(4px)", display: "grid", placeItems: "center", padding: 20 }}>
      <div onClick={e => e.stopPropagation()} style={{ width: `min(${width}px, 100%)`, maxHeight: "88vh", overflowY: "auto", background: "#f8f6ee", borderRadius: 26, padding: "22px 24px", boxShadow: "0 24px 70px rgba(20,20,20,0.3)", fontFamily: JAKARTA }}>
        {children}
      </div>
    </div>
  );
}
